import {
  BankDetailsSection,
  type BankDetailsConfig,
} from "@project/user/components/bank-details-section";

import upiQrImg from "@project/assets/ManavSeva/manav-seva-upi-qr.png";

const MANAV_SEVA_BANK_DETAILS: BankDetailsConfig = {
  orgName: "Manav Seva Samaj Kalyan Trust",
  bankName: "Kotak Mahindra Bank",
  branch: "Nr. Swaminarayan Tower, Maninagar",
  accountNumber: "9312459209",
  accountName: "Manavseva Samaj Kalyan Trust",
  ifsc: "KKBK0002584",
  pan: "AAATM8600J",
  taxNote: "Trust registered under 80-G of Income Tax Act",
  upiId: "manavsevakalyantrust@kotak",
  upiPayeeName: "MANAV SEVA SAMAJ KALYAN TRUST",
  qrImage: upiQrImg,
  qrDownloadName: "manav-seva-samaj-kalyan-trust-upi-qr.png",
};

/** Bank & UPI details for Tiffin Seva, Bhojanshala and general donations */
export function ManavSevaBankDetails() {
  return (
    <BankDetailsSection
      id="manav-seva-bank-details"
      details={MANAV_SEVA_BANK_DETAILS}
    />
  );
}
